// useSolutionPlanView.ts
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { GanttTabBarTab } from "../types/ganttChart";
import { useQueryParams } from "./useQueryParams";
import { PlanViewStateEntry } from "../store/realTimeUpdates";
import { RootState } from "../store";
import {
  createPlanViewStateKey,
  serializeKey,
} from "../store/realTimeUpdates/stateKeyUtils";
import { shallowEqual } from "react-redux";

/**
 * Stabile konstante state entries
 */
const LOADING_STATE: PlanViewStateEntry = { status: "loading" };
const MISSING_STATE: PlanViewStateEntry = { status: "missing" };

/**
 * Hook til at hente plan view state
 */
export const useSolutionPlanView = (selectedTab?: GanttTabBarTab) => {
  const queryKey = useQueryParams(selectedTab);

  // Selector inline med shallowEqual
  const planViewState = useAppSelector((state: RootState) => {
    if (
      !state.realTimeUpdateSlice ||
      Object.keys(state.realTimeUpdateSlice).length === 0
    ) {
      return LOADING_STATE;
    }

    if (!queryKey.solutionType || !queryKey.filterId || !queryKey.date) {
      return MISSING_STATE;
    }

    const key = createPlanViewStateKey(
      queryKey.solutionType,
      queryKey.filterId,
      queryKey.date
    );
    const serializedKey = serializeKey(key);

    return state.realTimeUpdateSlice[serializedKey] || MISSING_STATE;
  }, shallowEqual);

  return planViewState;
};
